<template>
  <section class="content-padding">
    <div class="row">
      <div class="col-6 offset-3">
        <div>Test Omise Add Card</div>
        <div class="mt-4">Omise Token: {{ omiseToken }}</div>
        <payment-form ref="paymentForm" :paymentData="paymentData" />
        <div class="mt-4">
          <button class="btn btn-primary" @click="testOmise()">
            Create Omise Token
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentForm from './PaymentForm'

export default {
  components: {
    PaymentForm
  },
  data () {
    return {
      paymentData: {
        name: null,
        number: null,
        expirationDate: '',
        securityCode: null,
        savePayment: true,
        displaySavePayment: false,
        isDefault: false
      },
      omiseToken: null
    }
  },
  computed: {
    ...mapGetters({
      globalState: 'globalVal/getState'
    })
  },
  methods: {
    testOmise () {
      if (this.$refs.paymentForm.paymentFormValidation()) {
        console.log('test create omise token')
        // Prepare card data
        const cardNumber = this.paymentData.number.replace(/\s+/g, '')
        let arrExpiration = this.paymentData.expirationDate.split('/')
        const expirationMonth = arrExpiration[0]
        const expirationYear = 2000 + parseInt(arrExpiration[1])

        const card = {
          name: this.paymentData.name,
          number: cardNumber,
          expiration_month: expirationMonth,
          expiration_year: expirationYear,
          security_code: this.paymentData.securityCode
        }
        // console.log('card', card)
        window.Omise.setPublicKey(this.globalState.omisePublicKey)
        window.Omise.createToken('card', card, (statusCode, response) => {
          if (statusCode === 200 && response.object === 'token') {
            const omiseToken = response.id
            this.omiseToken = omiseToken
            // console.log('omiseToken', omiseToken)
          } else {
            const alertText = 'Error: ' + response.message
            this.$swal({ text: alertText })
          }
        })
      }
    }
  },
  mounted () {
    console.log('hello world')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment/TestOmise.vue